
import { defineComponent } from 'vue';
import ModalButton from './util/ModalButton.vue';

export default defineComponent({ components: { ModalButton } });
